import { datadogRum } from "@datadog/browser-rum";
import { datadogLogs } from "@datadog/browser-logs";
import { createRoot } from "react-dom/client";
// @ts-expect-error pure js
import App from "./App.jsx";
import "./index.css";

import TagManager from "react-gtm-module";
import { TRACKING_ENABLED } from "./utils/metaPixel";
import { loadCookieYes } from "./utils/consent";
// @ts-expect-error pure js
import fr from "moment/locale/fr";
import moment from "moment/moment";
import { Crisp } from "crisp-sdk-web";

moment.locale("fr", fr);

const CLIENT_TOKEN = "pubbb0c366a67abbd9e787001f8a14887c0";
const APPLICATION_ID = "36ee2667-ebc3-41eb-ae25-d31d8fed500d";
const DATADOG_SITE = "datadoghq.com";
const SERVICE = "qalimo";
const VERSION = import.meta.env.VITE_VERSION;
const ENV = import.meta.env.VITE_ENV;

datadogLogs.init({
  clientToken: CLIENT_TOKEN,
  site: DATADOG_SITE,
  service: SERVICE,
  env: ENV,
  version: VERSION,
  forwardErrorsToLogs: true,
  sessionSampleRate: 100,
});

datadogRum.init({
  applicationId: APPLICATION_ID,
  clientToken: CLIENT_TOKEN,
  site: DATADOG_SITE,
  service: SERVICE,
  env: ENV,
  version: VERSION,
  sessionSampleRate: 100,
  sessionReplaySampleRate: 100,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  defaultPrivacyLevel: "mask-user-input",
  allowedTracingUrls: [
    (url) => url.startsWith(import.meta.env.VITE_BACKEND_URL),
  ],
});

datadogRum.startSessionReplayRecording();

if (TRACKING_ENABLED) {
  loadCookieYes();
  TagManager.initialize({ gtmId: "GTM-PNNW7745" });
}

Crisp.configure("66288575-6914-491d-acf8-c9adff31ca64");

createRoot(document.getElementById("root")!).render(<App />);
